__webpack_require__.p = "/referals-flag/referrals/";